const ZetaAiIcon = ({ size }: { size: string }) => (
  <svg width={size || '32'} height={size || '32'} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="#161C24" />
    <path d="M8.32413 20.4V17.8708L14.1655 12.5312V12.2502H8.52486V10.5038H16.4138V13.0531L10.5523 18.3927V18.6536H16.5743V20.4H8.32413Z" fill="white" />
    <circle cx="21.4743" cy="17.0243" r="3.37575" fill="#C684FF" />
  </svg>
);

export default ZetaAiIcon;
